// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Content = styled.div`
  padding: 16px 30px;
`;

export const TriggersHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
TriggersHeader.displayName = 'S.TriggersHeader';

export const TriggersTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 48px;
`;
TriggersTitle.displayName = 'S.TriggersTitle';

export const Spacer = styled.div`
  flex-grow: 1;
`;
Spacer.displayName = 'S.Spacer';
